/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const releaseEventSchema = z.enum(['announced'])

export type ReleaseEventSchema = z.infer<typeof releaseEventSchema>
